import styles from './index.module.scss';
import { ParkingTimeSection } from './parking-time-section';
import { ParkingInfoSection } from './parking-info-section';

interface PaymentInfoCardProps {
  checkedInAt: string;
  checkedOutAt: string;
  requestAmount: string;
  shouldLeaveBefore: string;
  currentPricePeriod: string[];
  amplitudeEventParams: { ticketId: string; plateNumber: string };
}

export const PaymentInfoCard = ({
  checkedInAt,
  checkedOutAt,
  requestAmount,
  shouldLeaveBefore,
  currentPricePeriod,
  amplitudeEventParams,
}: PaymentInfoCardProps) => {
  return (
    <div className={styles.card}>
      <ParkingTimeSection
        checkedInAt={checkedInAt}
        checkedOutAt={checkedOutAt}
      />
      <ParkingInfoSection
        checkedInAt={checkedInAt}
        checkedOutAt={checkedOutAt}
        requestAmount={requestAmount}
        shouldLeaveBefore={shouldLeaveBefore}
        currentPricePeriod={currentPricePeriod}
        amplitudeEventParams={amplitudeEventParams}
      />
    </div>
  );
};
